import riot from 'riot';
import events from '../src/events.js';
import { msalInstance, login, logout, isAuthenticated, getAccessToken, FILAMENT_API_ENDPOINT } from '../src/lib.js';
riot.tag2('main-nav', '<nav class="navbar" role="navigation" aria-label="main navigation"> <div class="navbar-brand"> <a class="navbar-item" href="https://www.edjro.com"> <img src="img/brand/Edjro_Primary_Logo_Emerald_Navy.png"> </a> <a role="button" class="navbar-burger burger {hamburger_active?\'is-active\':\'\'}" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample" onclick="{toggleHamburger}"> <span aria-hidden="true"></span> <span aria-hidden="true"></span> <span aria-hidden="true"></span> </a> </div> <div id="navbarBasicExample" class="navbar-menu {hamburger_active?\'is-active\':\'\'}"> <div class="navbar-start"> <a class="navbar-item" href="https://www.edjro.com/product-page/smart-kit-pre-order" target="_blank" rel="noopener noreferrer"> Filament Shop </a> <a class="navbar-item" onclick="{supportClick}"> Help & Support </a> </div> <div class="navbar-end"> <div class="navbar-item"> <div class="buttons"> <button class="button" if="{user}"> <span>{user.first_name} {user.last_name}</span> <span class="icon"> <img riot-src="{getUserAvatar()}" style="border-radius: 50%;" onerror="this.src=this.dataset.fallback" data-fallback="{getInitialsAvatar()}"> </span> </button> <button class="button is-{!user?\'success\':\'danger\'}" onclick="{authClick}">{!user?⁗Login⁗:⁗Logout⁗} </button> </div> </div> </div> </div> </nav>', '', '', function(opts) {
        var self = this;
        self.loading = true;
        self.user = undefined;
        self.hamburger_active = false;

        self.on('mount', function() {

            getUser();

            const account = msalInstance.getActiveAccount();
            if (account) {

                putUser({
                    name: account.name,
                    email: account.username,
                    user_id: account.localAccountId,
                });
            }
        });

        events.on('users_loaded', function(user) {

            self.hamburger_active = false;
            getUser();
        });

        events.on('auth_logout', function(data) {

            self.user = undefined;
            self.update();
        });

        this.toggleHamburger = function(e) {
            self.hamburger_active = !self.hamburger_active;
            self.update();
        };

        this.authClick = function() {
            if (isAuthenticated()) {
                logout();
            } else {
                login();
            }
        };

        this.supportClick = function() {

            window.open('support/index.html', '_blank');
        };

        function getUser() {
            user_profile = localStorage.getItem('profile');
            if (user_profile != "undefined" && user_profile) {
                self.update({
                    user: JSON.parse(user_profile)
                });
            }
        };

        this.getInitialsAvatar = function() {
            if (!self.user) return '';
            const name = (self.user.first_name || '') + ' ' + (self.user.last_name || '');
            return `https://ui-avatars.com/api/?name=${encodeURIComponent(name.trim())}&background=0e0e52&color=fff&size=64`;
        };

        this.getUserAvatar = function() {
            if (!self.user || !self.user.picture) return self.getInitialsAvatar();
            return self.user.picture;
        };

        async function putUser(data) {
            const token = await getAccessToken();
            if (!token) return;

            var url = `${FILAMENT_API_ENDPOINT}/PUTUser`;
            var my_headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            };

            fetch(url, {
                method: "PUT",
                headers: my_headers,
                body: JSON.stringify(data)
            }).then(function(res) {
                if (res.status == 401 || res.status == 500) {
                    localStorage.removeItem('profile');
                    localStorage.removeItem('accessToken');
                    events.emit('auth_logout', { reason: 'token_expired' })
                } else {
                    return res.json();
                }
            }).then(function(res) {
                if (res && res['data'] && res['data']['users']) {
                    localStorage.setItem('profile', JSON.stringify(res['data']['users'][0]));
                    events.emit('users_loaded', res['data']['users'][0])
                }
            }).catch(function(error) {
                console.error('PUT User Error:' + error);
                self.update({
                    error: error
                });
            }.bind(this));
        }
});
